import { Accessibility } from './../model/settings.model';
import { ParametersService } from './../service/parameters.service';
import { ReportService } from './../service/report.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Device, FinderData, SearchTag } from '../model/search';
import { HydratedTchek, Tchekb, TchekStatus } from '../model/tchekb.model';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { SearchService } from '../service/search.service';
import { AwsService } from '../service/aws.service';
import { GetTchekOpts, TchekService } from '../service/tchek.service';
import { ImagesService } from '../service/images.service';
import { ClassificationResultDataModel } from '../model/classificationDetection.model';
import { ToastService } from '../service/toast.service';
import { BarcodeFormat } from '@zxing/library';
@Component({
  selector: 'app-vinscanner',
  templateUrl: './vinscanner.component.html',
  styleUrls: ['./vinscanner.component.less']
})
export class VinscannerComponent implements OnInit {

  modalRef: NgbModalRef;
  @ViewChild('content') content: ElementRef;
  closeResult: string;
  accessibility: Accessibility;
  isSuperAdmin = false
  constructor(
    private modalService: NgbModal,
    private readonly i18n: I18n,
    public _searchService: SearchService,
    private _awsService: AwsService,
    public readonly _imagesService: ImagesService,
    private readonly _tchekService: TchekService,
    private readonly _parametersService: ParametersService,
    private readonly _routerService: Router,
    private readonly _reportService: ReportService,
    private readonly _toastService: ToastService,
  ) {
    this.isSuperAdmin = this._parametersService.isSuperAdmin
    this.accessibility = this._parametersService.getAll().accessibility;
    console.log('this._parametersService.getAll().accessibility', this._parametersService.getAll().accessibility);
    if (this._parametersService.getAll().accessibility === undefined)
      this.accessibility = { showIcons: false, useFastTrack: true, fastTrackComp: false, fastTrackZoom: true, showImmatPicture: true, fastTrackL1: true, fastTrackL2: true, fastTrackL3: true }
    if (this.accessibility.showImmatPicture === undefined) this.accessibility.showImmatPicture = true

  }

  ngOnInit() {

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  open() {

    let finderData = {
      activeFilters: [{ display: this.qrResultString, value: this.qrResultString }],
      isDateActive: false,
      limit: 15,
      skip: 0,
      date: undefined,
      isDownloaded: undefined,
      isPicturesHD: undefined,
      isPicturesXHD: undefined,
      minProbVehicle: undefined,
      scanAnalyzed: undefined,
      scanAnnotated: undefined,
      scanForValidation: undefined,
    }
    this._searchService.fuzzySearch(finderData as FinderData).then((r: HydratedTchek[]) => {
      if (r && r.length > 0) {
        this.openscan(r[0])
      } else {
        this._toastService.toastOpen(undefined, 'Pas de scan avec le vin' + this.qrResultString, 'error')
        this.modalRef.dismiss('Cross click')
        this.clearResult()
      }
    })

    this.modalRef = this.modalService.open(this.content, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {

      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.clearResult()
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;

  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.CODE_39,
    BarcodeFormat.CODE_128,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.EAN_13,
    BarcodeFormat.QR_CODE
  ];

  hasDevices: boolean;
  hasPermission: boolean;

  qrResultString: string;

  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = false;

  openscan(currentTchek: HydratedTchek) {
    if (!this.isSuperAdmin && currentTchek.isNew === true) {
      if (currentTchek.status === 1)
        currentTchek.status = 2;
      currentTchek.isNew = false;
      currentTchek.toSync = true;
    }
    var camera = 1
    var picture = 0
    if (currentTchek.picturesSelected) {
      if (currentTchek.picturesSelected["thumbnail"]) {
        camera = currentTchek.picturesSelected["thumbnail"].camera
        picture = currentTchek.picturesSelected["thumbnail"].picture
      }
    }
    console.log('this._parametersService.getAll().accessibility', this._parametersService.getAll().accessibility);

    console.log('use fast track : ', this._parametersService.getAll().accessibility, this.accessibility.useFastTrack);
    if (this.accessibility.useFastTrack !== false && currentTchek.damageControl === undefined && currentTchek.numberDamage > 0
      && currentTchek.numberNewDamage > 0) { // for testing => &&  environment.isLocal )
      this._routerService
        .navigate(['fasttrack', currentTchek.id])
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
      this.modalRef.dismiss('Cross click')
    } else
      this._reportService.getByTchek(currentTchek.id)
        .then(reports => {
          if (reports && reports.length < 1)
            this._reportService.create(currentTchek.id)
              .then(report => {
                this.opentchek(currentTchek, camera, picture)
              });
          else
            this.opentchek(currentTchek, camera, picture)
        });
  }

  opentchek(tchek, camera, picture) {
    if ([4,5,2].includes(tchek.type))
      this._routerService
        .navigate(['viewer', tchek.id, picture], { queryParams: { isPercent: false } })
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
    else {
      this._routerService
        .navigate(['player', tchek.id, camera, picture], { queryParams: { isPercent: false } })
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
    }
    this.modalRef.dismiss('Cross click')
  }

  clearResult(): void {
    this.qrResultString = null;
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
  }

  onCodeResult(resultString: string) {
    if ((this.qrResultString === undefined || this.qrResultString === null) && resultString.length === 17) {
      this.qrResultString = resultString;
      this.open()
    }
  }

  onDeviceSelectChange(selected: string) {
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.currentDevice = device || null;
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }


  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }


}



// WEBPACK FOOTER //
// ./src/app/vinscanner/vinscanner.component.ts